import React, { Component } from "react";
import "./UserProfileOption.scss";
import profile from "../../../assets/icons/header/profile_pic.png";
import { Link, withRouter } from "react-router-dom";

import { deleteLogin, deleteTokens } from "../../../auth";
import { notify } from "../../Notify/Notify";
import { gql } from "@apollo/client";
import { apolloClient } from "../../../index";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
} from "../../../common/UserDataReducer";
import { compose } from "redux";

class UserProfileOption extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showUserProfileOptionDialog: false,
      userProfilePic: profile,
    };

    this.userProfileOptionRef = React.createRef();
    this.handleClickOutsideOfUserProfileOption =
      this.handleClickOutsideOfUserProfileOption.bind(this);
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideOfUserProfileOption
    );

    this.props.location.state = {
      ...this.props.location.state,
      loadProfileImage: this.loadProfileImage,
    };
    this.loadProfileImage();
  }

  componentDidUpdate(prevProps) {
    const currentUserInfo = this.props.currentUserInfo;
    if (currentUserInfo !== prevProps.currentUserInfo) {
      if (Object.keys(currentUserInfo).length > 0) {
        if (currentUserInfo.profile.image) {
          this.setState({
            userProfilePic: currentUserInfo.profile.image,
          });
        }
      }
    }

    this.props.location.state = {
      ...this.props.location.state,
      loadProfileImage: this.loadProfileImage,
    };
  }

  loadProfileImage = () => {
    apolloClient
      .query({
        query: gql`
          query {
            me {
              profile {
                image
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        let data = result.data.me;

        if (data && data.profile.image) {
          this.setState({
            userProfilePic: data.profile.image,
          });
        }
      })
      .catch((err) => {
        this.linkOnClickHandler("logout");
      });
  };

  componentWillUnmount() {
    document.removeEventListener(
      "mousedown",
      this.handleClickOutsideOfUserProfileOption
    );
  }

  handleClickOutsideOfUserProfileOption(event) {
    if (
      this.userProfileOptionRef &&
      this.userProfileOptionRef.current &&
      !this.userProfileOptionRef.current.contains(event.target)
    ) {
      this.setState({ showUserProfileOptionDialog: false });
    }
  }

  openUserProfileOptionDialog = () => {
    let isOpen = !this.state.showUserProfileOptionDialog;
    if (isOpen) {
      this.setState({ showUserProfileOptionDialog: isOpen });
    } else {
      this.closeUserProfileOptionDialog();
    }
  };

  closeUserProfileOptionDialog = () => {
    this.setState({ showUserProfileOptionDialog: false });
  };

  linkOnClickHandler = (source) => {
    this.setState({ showUserProfileOptionDialog: false });
    if (source === "profile") {
      this.props.history.push("/user-profile");
    } else if (source === "logout") {
      deleteTokens();
      deleteLogin("login");
      this.props.history.push("/login");

      //logout message
      const title = "Success";
      const detail = "User Logged out successfully!";
      const type = "success";
      notify(title, detail, type);
    }
  };

  render() {
    return (
      <div
        className="user-profile-option-container"
        ref={this.userProfileOptionRef}
      >
        <img
          className="user-profile-option-icon rounded-circle img-responsive"
          onClick={this.openUserProfileOptionDialog}
          src={this.state.userProfilePic}
          alt="User Profile"
        />

        {this.state.showUserProfileOptionDialog ? (
          <div
            className={`user-profile-option-container ${
              this.state.showUserProfileOptionDialog ? "show" : "hide"
            }`}
          >
            <Link to="#" onClick={() => this.linkOnClickHandler("profile")}>
              Profile
            </Link>
            <a
              href="https://tikler.notion.site/Tikler-Knowledge-Base-f16fe3c7e16143c9b81c4b667bbd83f3"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Knowledge Base"
            >
              Knowledge Base
            </a>
            <Link to="#" onClick={() => this.linkOnClickHandler("logout")}>
              Logout
            </Link>
          </div>
        ) : null}
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(UserProfileOption);

// export default withRouter(UserProfileOption);
